const register = () => {
    $('#phone').mask('000000000');
    $('#nip').mask('0000000000');
            
    var slider_join = $('#join-list');

    if( slider_join.length > 0 ){

        slider_join.on('init', function(event, slick, direction){
            $(this).addClass('show')
        });

        slider_join.slick({
            infinite: false,
            centerMode: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
        });
        
        var timerJoin = 0;

        function showJoinItems(elem, timer){
            $("#" + elem).find('.item').find('span').each(function(){
                var that = $(this);

                setTimeout(function(){
                    $(that).toggleClass("bounceIn animated")
                },timer);

                timer = timer + 125;
            })
        }

        new Waypoint({
            element: document.getElementById('join-section'),
            handler: function(direction) {
                showJoinItems('join-list', timerJoin)
            },
            offset: '60%'
        });
    }

    var timerHowItRegisterWorks = 0;

    function showHowItWorksRegisterItems(elem, timer){
        $("#" + elem).find('li').each(function(){
            var that = $(this);

            setTimeout(function(){
                $(that).toggleClass("bounceIn animated")
            },timer);

            timer = timer + 125;
        })
    }

    new Waypoint({
        element: document.getElementById('how-it-works-register-section'),
        handler: function(direction) {
            showHowItWorksRegisterItems('how-it-works-register-list', timerHowItRegisterWorks);
        },
        offset: '60%'
    });

    $('#go-to-register-form').click(function(){
        var offset = $('#register-panel').offset().top;

        $('html, body').animate({
            scrollTop: offset
        }, 500);
    })
    
    function validateNip(nip) {
        var nipWithoutDashes = nip.replace(/-/g,"");
        var reg = /^[0-9]{10}$/;
        if(reg.test(nipWithoutDashes) == false) {
            return false;
        } else {
            var digits = (""+nipWithoutDashes).split("");
            var checksum = (6*parseInt(digits[0]) + 5*parseInt(digits[1]) + 7*parseInt(digits[2]) + 2*parseInt(digits[3]) + 3*parseInt(digits[4]) + 4*parseInt(digits[5]) + 5*parseInt(digits[6]) + 6*parseInt(digits[7]) + 7*parseInt(digits[8]))%11;

            return (parseInt(digits[9])==checksum);
        }
    }

    $('#register-form').submit(function(){
        var error = false;
        
        var nip = $('input#nip').val().trim();;
        var email = $('input#email').val().trim();;
        var phone = $('input#phone').val().trim();;
        var accept = $('#accept1').prop('checked');
       
        $('.form-group').removeClass('error');
        $('.note.error').remove();
        
        $('input#nip').attr('value', nip);
        if (nip == "" || !validateNip(nip)) { 
            $('input#nip').closest('.form-group').addClass('error');
            error = true;
        }
        
        var email_compare = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        $('input#email').attr('value', email);
        if (email == "" || email == " ") { 
            $('input#email').closest('.form-group').addClass('error');
            error = true;
        }
        else if (!email_compare.test(email)) { 
            $('input#email').closest('.form-group').addClass('error');
            error = true;
        }
        
        $('input#phone').attr('value', phone);
        if (phone == "") { 
            $('input#phone').closest('.form-group').addClass('error');
            error = true;
        }
        
        if (accept == false) {
            $('input#accept1').closest('.form-group').addClass('error');
            error = true;
        }
        
        if (error) {
            return false;
        }
    });
    
 }

 module.exports = {
    register,
 };